<div class="modal-dialog" >
    <div class="modal-content">
        <div class="modal-body">
            <div class="address-modal-title">
                <a data-bs-dismiss="modal"
                aria-label="Close"><img src="assets/images/back-arrow.svg" alt="arrow" /></a>
                <h4>My Addresses</h4>
            </div>
            <form class="add-new-address-detail" [formGroup]="addressFormgroup" (ngSubmit)="onSubmit()">
                <div class="modal-header py-0 d-lg-flex d-none   justify-content-end">
                    <button class="modal-button" type="button" data-bs-dismiss="modal" aria-label="Close"><img src="assets/images/close-icon.png" alt="close" (click)="closeModal(false)"></button>
                </div>
                <div class="add-new-address-detail-input row">
                    <div class="address-modal-title add-new-btn d-lg-flex d-none mb-3">
                        <h4>add new addresses</h4>
                    </div>
                    <div class="mb-3">
                        <div class="default-address-checkbox">
                            <input type="checkbox" [id]="addressData && addressData.id ? from+addressData.id : from+'checkbox-0'" [name]="from" [checked]="addressData?.is_default" formControlName="is_default">
                            <label [for]="addressData && addressData.id ? from+addressData.id : from+'checkbox-0'">Use this as default address</label>
                        </div>
                    </div>
                    <div class="mb-3 col-lg-6 col-md-12">
                        <label>First Name</label>
                        <input type="text" formControlName="first_name" placeholder="First Name">
                    </div>
                    <div class="mb-3 col-lg-6 col-md-12">
                        <label>Last Name</label>
                        <input type="text" formControlName="last_name" placeholder="Last Name">
                    </div>
                    <div class="mb-3 col-lg-6 col-md-12">
                        <label>Pincode</label>
                        <input type="text" formControlName="postal_code" placeholder="Enter Pincode">
                        <div *ngIf="getAddressForm['postal_code'].touched && getAddressForm['postal_code'].invalid"
                            class="alert alert-danger alert-text">
                            <div *ngIf="getAddressForm['postal_code'].errors && getAddressForm['postal_code'].errors['required']">
                                Pin code is required.</div>
                      </div>
                    </div>
                    <div class="mb-3 col-lg-6 col-md-12 d-lg-block d-none">
                        <label>City</label>
                        <input type="text" placeholder="Enter City" formControlName="city" readonly>
                        <div *ngIf="getAddressForm['city'].touched && getAddressForm['city'].invalid"
                        class="alert alert-danger alert-text">
                        <div *ngIf="getAddressForm['city'].errors && getAddressForm['city'].errors['required']">
                            City is required.</div>
                  </div>
                    </div>
                    <div class="mb-3 " >
                        <label>Address</label>
                        <textarea placeholder="Enter Full Address" formControlName="address_line1"></textarea>
                        <div *ngIf="getAddressForm['address_line1'].touched && getAddressForm['address_line1'].invalid"
                        class="alert alert-danger alert-text">
                        <div *ngIf="getAddressForm['address_line1'].errors && getAddressForm['address_line1'].errors['required']">
                            Address is required.</div>
                  </div>
                    </div>
                    <div class="mb-3 d-lg-none d-block">
                        <label>City</label>
                        <input type="text" placeholder="Enter City" formControlName="city" readonly>
                        <div *ngIf="getAddressForm['city'].touched && getAddressForm['city'].invalid"
                        class="alert alert-danger alert-text">
                        <div *ngIf="getAddressForm['city'].errors && getAddressForm['city'].errors['required']">
                            City is required.</div>
                  </div>
                    </div>
                    <div class="mb-3 col-lg-6 col-md-12">
                        <label>State</label>
                        <input type="text" placeholder="Enter State" formControlName="state_name" readonly>
                        <div *ngIf="getAddressForm['state_name'].touched && getAddressForm['state_name'].invalid"
                        class="alert alert-danger alert-text">
                        <div *ngIf="getAddressForm['state_name'].errors && getAddressForm['state_name'].errors['required']">
                            State name is required.</div>
                  </div>
                    </div>
                    <div class="mb-3 col-lg-6 col-md-12">
                        <label>Mobile Number</label>
                        <input maxlength="10" formControlName="contact_number1" name="contact_number1" type="text" placeholder="Enter Mobile number" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');">
                        <div *ngIf="getAddressForm['contact_number1'].touched && getAddressForm['contact_number1'].invalid"
                        class="alert alert-danger alert-text">
                        <div *ngIf="getAddressForm['contact_number1'].errors && getAddressForm['contact_number1'].errors['required']">
                            Mobile number is required.</div>
                  </div>
                    </div>
                    <ul class="save-and-close new-save-btn d-lg-block d-none">
                        <li><button type="submit" class="save-dark" [ngClass]="{'no-pointer-events': isLoading, '': !isLoading}"> <i *ngIf="isLoading" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': isLoading, '': !isLoading}"></i> Save Details</button></li>
                    </ul>
                </div>
                <ul class="save-and-close d-lg-none d-block">
                    <li><button type="submit" class="save-dark" [ngClass]="{'no-pointer-events': isLoading, '': !isLoading}"> <i *ngIf="isLoading" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': isLoading, '': !isLoading}"></i> Save Details</button></li>
                    <li><button class="cancel-border" data-bs-dismiss="modal" 
                        (click)="closeModal(false);" aria-label="Close">Cancel</button></li>
                </ul>
            </form>
        </div>
    </div>
</div>

